<template>
    <div class="board-container">
        <div role="table" class="board-table board-table--inquiry">
            <div role="rowgroup">
                <div role="row">
                    <div role="columnheader" class="num">번호</div>
                    <div role="columnheader" class="title">서비스명</div>
                    <div role="columnheader" class="cell">신청일</div>
                </div>
            </div>
            <div v-for="(application, index) in applications" :key="application._id" role="rowgroup">
                <router-link role="row" :to="getTo(application)">
                    <div role="cell" class="num">{{ (page - 1) * limit + index + 1 }}</div>
                    <div role="cell" class="title">
                        <div class="title">{{ application?.program?.title || '삭제된 프로그램입니다' }}</div>
                    </div>
                    <div role="cell" class="cell date">
                        <span class="date">{{ application.createdAt.toDate() }}</span>
                    </div>
                </router-link>
            </div>
        </div>

        <pagination-component v-model="page" :count="pageCount" @input="search"></pagination-component>

        <!-- <div class="board-buttons">
            <div class="left">
                <a class="button button--border" href=""><span>리스트</span></a>
            </div>
        </div> -->
    </div>
</template>

<script>
import api from "@/api";
import { SERVICE_PROGRAM_CATEGORIES } from "@/assets/variables";

import PaginationComponent from "@/components/client/control/pagination-component.vue";

export default {
    components: {
        PaginationComponent,
    },
    props: ["category"],
    computed: {
        title() {
            return SERVICE_PROGRAM_CATEGORIES[this.category?.toUpperCase?.()]?.text || null;
        },
        type() {
            return SERVICE_PROGRAM_CATEGORIES[this.category?.toUpperCase?.()]?.value || null;
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
    },
    data() {
        return {
            filter: {},

            page: 1,
            pageCount: 0,
            limit: 20,

            applications: [],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.search();
        },

        getTo(application) {
            return `${this.$route.path}/${application._id}`;
        },

        async search(routable = true) {
            try {
                const { skip, limit, type } = this;
                var { summary, applications } = await api.v1.services.applications.gets({
                    headers: { skip, limit },
                    params: { ...this.filter, type },
                });

                this.summary = summary;
                this.pageCount = Math.ceil(summary.totalCount / limit);
                this.applications = applications;
            } catch (error) {
                this.$handleError(error);
            }
        },
    },
    watch: {
        $route() {
            this.search(false);
        },
    },
};
</script>
